// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"df859c5d","488":"dcf3841f","977":"ff9c9a1a"}[chunkId] + ".chunk.js";
};